import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { fetchPartnersAndContactsEffect } from '../effects/fetchPartnersAndContactsEffect'
import { updatePartnerSearchFilters } from '../partnerSearchSlice'

listenerMiddleware.startListening({
  actionCreator: updatePartnerSearchFilters,
  effect: fetchPartnersAndContactsEffect,
})
